<!--
 * @Author: your name
 * @Date: 2020-08-11 21:01:30
 * @LastEditTime: 2022-12-02 10:13:42
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/App.vue
-->
<template>
  <div
    v-if="isRouterAlive"
    ref="app"
    id="app"
    :class="{'nav_bar_top': navConfig.barShow && isMobile}"
    @click="contronShowReportBugDialog"
  >
    <nav-bar
      class="bar_top"
      v-if="navConfig.barShow"
      v-model="showManageCenter"
      :barTitle="venueName"
      :showArrow="navConfig.showArrow"
      @prev="prev"
    ></nav-bar>
    <router-view class='router'></router-view>
    <!-- 多版本菜单 B6（U-B6-3）：菜单预览横幅（地址里没有预览码时不渲染）；导航栏显示时排在它下面（U-B6-2 review 第 2 轮 G12） -->
    <preview-menu-banner :below-nav-bar="!!navConfig.barShow" />
    <py-loading :showLoading="showLoading" :hideTop="hideTop"></py-loading>
    <div class='fill_blank'></div>
    <bottom-popup-dialog
      class="popup"
      :show-close-icon="showCloseIcon"
      v-model="showNotMainNavigatorPopupDialog"
    >
      <template v-slot:popup-dialog>
        <not-common-navigator-content
          :venue-url="venueUrl"
        />
      </template>
    </bottom-popup-dialog>
    <bottom-popup-dialog
      class="popup"
      :show-close-icon="showReportBugDialogSettings.showCloseIcon"
      v-model="showReportBugPopupDialog"
    >
      <template v-slot:popup-dialog>
        <report-bug-content
          :value-fields="valueFields"
          @closeReportBugDialog="closeReportBugDialog"
        />
      </template>
    </bottom-popup-dialog>
    <left-popup-dialog
      class="left_popup"
      v-model="showManageCenter"
    >
      <template v-slot:popup-dialog>
        <manage-center-content
          :user-has-tab="userHasTab"
          :menu-list="menuList"
          @closeManageCenterDialog="closeManageCenterDialog"
          @openLanguageModal="showDrawerLanguageModal = true"
          @openCurrencyModal="showDrawerCurrencyModal = true"
        />
      </template>
    </left-popup-dialog>
    <!-- Language/Currency modals rendered outside drawer to avoid van-popup clipping -->
    <language-selector-modal
      :show="showDrawerLanguageModal"
      :languages="drawerLanguages"
      :currentLanguage="drawerCurrentLanguage"
      @select="onDrawerSelectLanguage"
      @close="showDrawerLanguageModal = false"
    />
    <currency-selector-modal
      :show="showDrawerCurrencyModal"
      :currencies="drawerCurrencies"
      :currentCurrency="drawerCurrentCurrency"
      @select="onDrawerSelectCurrency"
      @close="showDrawerCurrencyModal = false"
    />
    <van-overlay :show="dialogShow" class="overlay">
      <div class="svg_box">
        <div class="arrow_svg_icon">
          <svg-icon color="#fff" icon-class="arrow" />
        </div>
      </div>
      <p class="title">{{ t('open_in_browser', 'Please click on the top right corner and open in your browser') }}</p>
      <van-button class="got_it ls3" @click="closeAppInBrowserNotice"> {{ t('got_it', 'Got It') }} </van-button>
    </van-overlay>
  </div>
</template>

<style scoped lang="sass">
#app
  display: flex
  flex-direction: column
  height: var(--heightPhone)

.overlay
  z-index: 10

  .svg_box
    align-self: flex-start
    height: 160PX
    display: flex
    justify-content: flex-end
    flex: 1

    .arrow_svg_icon
      height: 100%
      margin-left: 50%

.title
  padding: 10px
  color: #fff
  text-align: center
  font-size: 20px
  border-radius: 10px

.icon
  position: fixed
  top: 20px
  right: 40px

.router
  display: flex
  flex-direction: column

.show_bar
  padding-top: 58px

.fill_blank
  position: fixed
  bottom: 0
  width: 100%
  height: constant(safe-area-inset-bottom)
  height: env(safe-area-inset-bottom)
  background-color: #fff

.nav_bar_top
  padding-top: 58px

.bar_top
  position: fixed
  top: 0

.got_it
    margin: auto
    height: 38px
    border: none
    border-radius: 4px
    background-color: var(--menu-primary-background-colour)
    font-size: 15px
    text-align: center
    color: #fff
    border-radius: 5px !important
    justify-content: center
    align-items: center
    display: flex

.pc_nav_bar
  display: flex
  align-items: center
  padding: 0 39PX
  width: 100%
  height: 49PX
  background: #fff
  border-bottom: 1PX solid #EBEBEC

.home_menu
  position: absolute
  top: 7PX
  padding: 0 0 0 38PX
  border: 0
</style>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getUser, getVenue, } from '@/api/product'
import dayjs from 'dayjs'
import { _isIncludesMainNavigator, isIOS } from '@/utils/navigator'
import NotCommonNavigatorContent from 'components/NotCommonNavigatorContent'
import ReportBugContent from 'components/ReportBugContent'
import ManageCenterContent from 'components/ManageCenterContent'
import { vuexLoading } from 'utils/decorators'
import { safeDecodeURI } from 'utils'
import { _hexToRgb } from './utils/format'
import { submitBug } from 'api/submit-bug'
import html2canvas from 'html2canvas'
import {
  IS_FROM_MENU_TO_CONTACT_DETAIL,
  IS_FROM_MENU_TO_START_TAB,
  IS_FROM_ORDER_HISTORY_TO_ORDER_DETAIL,
  IS_FROM_START_TAB_TO_CARD_DETAILS,
  IS_SAME_PAGE_NAME,
} from 'modules/app'
import { mapState, } from 'vuex'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import resizeHandler from 'utils/resizeHandler'
import { t } from '@/utils/language'
import { resolveMerchantRate } from '@/utils/surchargeRate'
import { refreshSurchargeSnapshot, surchargeSourceOf } from '@/utils/surchargeSnapshot'
import LanguageSelectorModal from '@/components/LocaleSelector/LanguageSelectorModal.vue'
import CurrencySelectorModal from '@/components/LocaleSelector/CurrencySelectorModal.vue'
import { initAbForceFromUrl } from '@/utils/abForce'
import { setVenueMetaOnce } from '@/utils/venueOpenReplayMeta'
import PreviewMenuBanner from '@/components/PreviewMenuBanner'
import { withoutShareCodes } from '@/utils/menu/shareCodes'
import { menuCopyUrl } from '@/utils/menu/menuAddress'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(advancedFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

@Component({
  mixins: [resizeHandler],

  requiredComponents: ['global-base', 'global-popup', 'vant-base'],

  created() {
    this._addDisabledJumpButton()
  },

  provide() {
    return {
      name: 'provide',
      reload: this.reload
    }
  },

  metaInfo: {
    title: 'MondoMenu - Create a better ordering experience and drive loyalty to grow your revenue',
  },

  components: {
    NotCommonNavigatorContent,
    ReportBugContent,
    ManageCenterContent,
    LanguageSelectorModal,
    CurrencySelectorModal,
    PreviewMenuBanner
  },

  computed: {
    ...mapState(['isFromMenuToContactDetail', 'discountRuleTime']),
    // showLoading，是从 vuex 中获取的
    ...mapState({
      isOnline: state => state.app.isOnline,
      showLoading: state => state.app.showLoading,
      timeZone: state => state.venueHome.timeZone,
    }),

    // 从 vuex 中拿到 productname 与 vuenueName
    venueName() {
      // 动态的 titleBar 页面。也就是说 titleBar 会随着情况而改变。
      // unstatle titleBar condition, the same page's titleBar name will be changed with the special conditions.
      const unstableTitleBarNameList = ['contact-details']
      if (unstableTitleBarNameList.includes(this.$route.name)) {
        return this.isFromMenuToContactDetail ? 'Start a tab' : this.$route.meta.barTitle
      }

      // 固定的 titleBar 的页面显示，会根据接口中返回值来决定内容。
      // stable titleBar condition, the same page's titleBar name will be confirmed with the result from the API.
      const titleNavList = [
        'venue-home-table',
        'venue-home-pick',
        'product-detail-pick',
        'product-detail-table',
        // SP 模式的路由
        'venue-home-table-sp',
        'venue-home-table-sp-alt',
        'venue-home-no-table-sp',
        'venue-home-pick-sp',
        'product-detail-pick-sp',
        'product-detail-table-sp',
      ]
      if (titleNavList.includes(this.$route.name)) {
        // venue-home 页面显示 venue 名称
        const venueHomeRoutes = [
          'venue-home-table', 'venue-home-pick',
          'venue-home-table-sp', 'venue-home-table-sp-alt', 'venue-home-no-table-sp', 'venue-home-pick-sp'
        ]
        // product-detail 页面显示 product 名称
        const productDetailRoutes = [
          'product-detail-table', 'product-detail-pick',
          'product-detail-table-sp', 'product-detail-pick-sp'
        ]
        if (venueHomeRoutes.includes(this.$route.name)) {
          return this.$store.state.navTitle.venueName
        } else if (productDetailRoutes.includes(this.$route.name)) {
          return this.$store.state.navTitle.productName
        }
      } else {
        const titleShowList = [
          'my-order',
          'my-order-sp',
          'pay',
          'pay-sp'
        ]
        let mark = ''
        if (titleShowList.includes(this.$route.name)) {
          if (this.isOnline) return 'Thank you for your order'
          const isMyOrderRoute = ['my-order', 'my-order-sp'].includes(this.$route.name)
          const isPayRoute = ['pay', 'pay-sp'].includes(this.$route.name)
          if (isMyOrderRoute || isPayRoute) {
            mark = 'Order #'
            if (!this.isPostPaid && isMyOrderRoute) {
              return this.isCounterPay ? t('order_received_title', 'Order received') : t('payment_received', 'Payment received')
            }
          }
          return `${mark}${this.$route.query.orderNo}`
        }
        return this.$route.meta.barTitle
      }
    },

    isPostPaid() {
      return this.$store.state.isPostPaid
    },

    isCounterPay() {
      return this.$store.state.isCounterPay
    },
  },

  watch: {
    // 监听路由的变化。因为是动态路由，所以每个页面都会有变化。
    $route(to, from) {
      // 判断当前是否是 online 系统
      this.$store.commit('saveIsOnline', to.path.includes('/online/') || from.path.includes('/online/'))
      if (to.path === '/pc') return
      // 监听页面的跳转
      this._listenRouterChange(to, from)
      // 清除老版本的一个兼容
      this._clearOldVersionUnPaidOrderLocalStorage()
      // app.vue 会发送 ajax
      const notRequestVenueInfoList = [
        'venue-group',
        'venue-sub-group',
        'venue-sub-group-contact-details',
        'venue-sub-group-payment',
        'venue-sub-group-cart-table',
        'venue-sub-group-cart-pick',
        'venue-sub-group-my-order',
        'venue-sub-group-my-order-status',
        'venue-sub-group-card-detail',
        'venue-sub-group-order-history',
        'error-page',
        'venue-terms',
        'venue-privacy',
        'not-find-venue',
        'aov',
        'delivery/pickup'
      ]

      // notRequestVenueInfoList 中的路由，不需要调取 API。其他路由改变时，都是要调取 API 并把返回值存起来的。
      if (notRequestVenueInfoList.includes(this.$route.name)) {
        // 在 vuex 中，设置初始的 color。
        this._setDefaultColor()
        // For sub-group child pages, restore language/currency from saved sub-group settings
        // 对于 sub-group 子页面，从已保存的 sub-group 设置中恢复语言/货币
        this._restoreSubGroupLocaleSettings()
      } else {
        this._checkUserHasTab()
        // 在 vuex 中，设置初始的 color。
        this._setDefaultColor()
        this.venueId = this.$route.params.venueId
        // 获取 venue 中的 color 信息。
        this.$store.commit('saveRequestResult', false)
        this._postVenue()
          .then(res => {
            this._sendMsgToBacken()
            this.getVenueUrl()
            this.controlShowNotMainNavigatorPopupDialog()
            this.$store.commit('saveRequestResult', true)
          })
          .catch(
            // this.$store.commit('saveRequestResult', false)
          )
      }
      // 获取 router 中的的 meta 设定，来控制是否显示对应内容。
      this.navConfig.barShow = this.$route.meta.barShow
      this.navConfig.showArrow = this.$route.meta.showArrow
      this.navConfig.showIcon = this.$route.meta.showIcon
      // 隐藏 top 的路由列表
      const hideTopList = [
        'venue-home-pick',
        'venue-home-table',
        'product-detail-pick',
        'product-detail-table',
      ]
      if (hideTopList.includes(this.$route.name)) {
        if (this.$route.name === 'venue-home-pick' || this.$route.name === 'venue-home-table') {
          this.hideTop = true
          if (localStorage.getItem('showMask') === 'show') {
            this.hideTop = false
          } else {
            this.hideTop = true
          }
        } else {
          this.hideTop = true
        }
      } else {
        this.hideTop = false
      }
    },

    userHasTab(val) {
      val ? this._resetShowManageTab() : this._resetShowCreateTab()
    },

    // 显示左侧菜单栏时，重新计算并渲染菜单列表
    showManageCenter(val) {
      if (val) {
        this.userHasTab ? this._resetShowManageTab() : this._resetShowCreateTab()
      }
    },

    timeZone: {
      handler(val) {
        // 默认是墨尔本时间
        if (val) dayjs.tz.setDefault(val)
        else dayjs.tz.setDefault('Australia/Melbourne')
      },
      immediate: true
    }
  },
})

class Home extends Vue {
  menuList = [
    {
      icon: 'restaurant_menu',
      title: 'Menu',
      show: true,
      page: 'venue-home'
    },
    {
      icon: 'receipt_long',
      title: 'Order history',
      show: true,
      page: 'order-history'
    },
    {
      icon: 'account_balance_wallet',
      title: 'Start a tab',
      show: true,
      page: 'start-tab'
    },
    {
      icon: 'account_balance_wallet',
      title: 'Manage Tab',
      show: false,
      page: 'tab-menu'
    },
  ]

  dialogShow = false
  userHasTab = null

  // Drawer modal state / 抽屉弹窗状态
  showDrawerLanguageModal = false
  showDrawerCurrencyModal = false

  get drawerLanguages() {
    return this.$store.state.language?.supportedLanguages || []
  }

  get drawerCurrentLanguage() {
    return this.$store.state.language?.currentLanguage || 'en'
  }

  get drawerCurrencies() {
    return this.$store.state.currencySettings?.supportedCurrencies || []
  }

  get drawerCurrentCurrency() {
    return this.$store.state.currencySettings?.currentCurrency || 'AUD'
  }

  onDrawerSelectLanguage(langCode) {
    this.$store.dispatch('language/changeLanguage', langCode)
    this.showDrawerLanguageModal = false
  }

  onDrawerSelectCurrency(currCode) {
    this.$store.dispatch('currencySettings/changeCurrency', currCode)
    this.showDrawerCurrencyModal = false
  }

  showManageCenter = false
  shortCutSrc = ''
  disabledButton = false
  valueFields = {
    comment: ''
  }

  showReportBugPopupDialog = false
  showReportBugDialogSettings = {
    clickTime: 4,
    wasteTime: 1000,
    showCloseIcon: true
  }

  clickTime = 0
  timer = null
  showCloseIcon = false
  venueUrl = ''
  showNotMainNavigatorPopupDialog = false
  isRouterAlive = true
  venueInfo = {}
  venueId = ''
  hideTop = true
  navConfig = {
    barShow: false,
    showArrow: true,
    showIcon: ''
  }

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  mounted() {
    // A/B test framework: parse ?ab_force=<variant> from URL into sessionStorage
    // so the axios interceptor can attach X-Force-Variant on subsequent calls.
    // A/B 测试框架：把 URL 上的 ?ab_force=<变体> 写入 sessionStorage，
    // 后续 axios 请求会带上 X-Force-Variant header。
    initAbForceFromUrl()

    // 给 currentVenueTime 设置默认值
    this.$store.commit('saveCurrentVenueTime', dayjs.tz().format('YYYY-MM-DD HH:mm:ss'))
    this._verificationDiscountRuleTime()
    this._browserType()
    // 清空本地缓存 hideReadOnlyDialog
    localStorage.removeItem('hideReadOnlyDialog')
    this.$store.commit('saveAlcoholButton', false)
  }

  destroyed() {
    this.$store.commit('addDeliveryInfo', null)
  }

  // 校验会员时间，若储存超过 24 小时，清除缓存
  _verificationDiscountRuleTime() {
    if (!this.discountRuleTime) return
    const time = dayjs().diff(dayjs.unix(this.discountRuleTime), 'hour')
    if (time < 24) return
    this.$store.commit('clearDiscounts')
  }

  _resetShowManageTab() {
    this.menuList.splice(2, 1, {
      icon: 'account_balance_wallet',
      title: 'Manage Tab',
      show: true,
      page: 'tab-menu'
    },)
    this.menuList.splice(3, 1, {
      icon: 'account_balance_wallet',
      title: 'Start a tab',
      show: false,
      page: 'start-tab'
    },)
  }

  _resetShowCreateTab() {
    this.menuList.splice(2, 1, {
      icon: 'account_balance_wallet',
      title: 'Manage Tab',
      show: false,
      page: 'tab-menu'
    },)
    this.menuList.splice(3, 1, {
      icon: 'account_balance_wallet',
      title: 'Start a tab',
      show: this.$store.state.enableTab,
      page: 'start-tab'
    },)
  }

  async _checkUserHasTab() {
    const userId = localStorage.getItem('userId')
    const notificationKey = localStorage.getItem('notificationKey') || ''
    if (userId) {
      const data = { id: userId, notificationKey: notificationKey }
      const res = await getUser(data).catch(function (e) {
        console.log(e)
        if (e.indexOf('Can not found user') >= 0) {
          localStorage.removeItem('userId')
        }
      })
      this._saveUserInfo(res.currentTab)
    } else if (this.isMobile) {
      this._resetShowCreateTab()
      this._clearCurrentTab()
    }
  }

  _clearCurrentTab() {
    this.$store.commit('saveTabInfo', {
      prop: 'currentTab',
      val: null
    })
  }

  _saveCurrentTab(currentTab) {
    this.$store.commit('saveTabInfo', {
      prop: 'currentTab',
      val: currentTab
    })
  }

  _saveUserInfo(currentTab) {
    this.userHasTab = !!(currentTab && currentTab.find(item => item.venueId === (this.$store.state?.venueId ?? this.venueId)))
    this._saveCurrentTab(currentTab)
  }

  // 逐个监听路由变化
  _listenRouterChange(to, from) {
    this._isFromOrderHistoryToOrderDetail(to, from)
    this._isFromMenuToStartTab(to, from)
    this._isFromStartTabToCardDetails(to, from)
    this._isFromMenuToContactDetail(to, from)
    this._hasOrderInfoInCardDetailPage(to, from)
  }

  _hasOrderInfoInCardDetailPage(toPage, fromPage) {
    const targetPageList = ['start-tab']
    const allowFromPageList = ['card-detail']
    const mutationName = 'saveHasOrderInfoInCardDetailPage'
    // console.log(fromPage)

    if (targetPageList.includes(toPage.name) && fromPage.name === IS_SAME_PAGE_NAME) {
      // do nothing
      // console.log('fresh self')
    } else {
      const hasOrderInfo = _checkHasOrderInfo(fromPage.query)
      // fresh other page
      if (targetPageList.includes(toPage.name) && allowFromPageList.includes(fromPage.name) && hasOrderInfo) {
        this.$store.commit(mutationName, true)
      } else {
        this.$store.commit(mutationName, false)
      }
    }

    function _checkHasOrderInfo(query) {
      if (query) {
        return (query.createOrderId && query.createOrderNo) || (query.orderId && query.orderNo)
      }
    }
  }

  closeManageCenterDialog() {
    this.showManageCenter = false
  }

  _addDisabledJumpButton() {
    const self = this
    window.addEventListener('message', function(e) {
      if (e.data.name === 'isIframe') {
        self.disabledButton = true
      }
    })
  }

  @vuexLoading
  async closeReportBugDialog() {
    await this._postSubmitBug()
    this.showReportBugPopupDialog = false
    this.resetComment()
  }

  resetComment() {
    this.valueFields.comment = ''
  }

  async _postSubmitBug() {
    const userId = localStorage.getItem('userId')
    const data = {
      venueId: this.venueId,
      comment: this.valueFields.comment,
      details: {
        browser: window.navigator.userAgent,
        isIOS: isIOS(),
        path: this.$route.name,
        // 多版本菜单 B6（U-B6-2 review 第 2 轮 G10）：菜单预览码不跟着 bug 报告送到服务器（别的参数原样）；
        // N35（review R4B5-4）：点单链接码同样去掉 —— 这个地址经后端拼进 ClickUp 任务描述（第三方）
        url: withoutShareCodes(window.location.href),
        shortCut: this.shortCutSrc,
        playId: localStorage.getItem('openreplayUserId') ?? '',
        sessionId: localStorage.getItem('openreplaySessionID') ?? '',
        userData: JSON.parse(localStorage.getItem('vuex'))
      }
    }
    if (userId) Object.assign(data, { userId })
    await submitBug(data)
  }

  _showReportBugDialog() {
    return new Promise((resolve, reject) => {
      this.clickTime++
      if (!this.timer) {
        this.timer = setTimeout(() => {
          if (this.clickTime >= this.showReportBugDialogSettings.clickTime && self === top) {
            resolve(true)
          } else {
            reject(new Error('click time is not enough to invoke report bug dialog'))
          }
          this.timer = null
          this.clickTime = 0
        }, this.showReportBugDialogSettings.wasteTime)
      }
    })
  }

  async contronShowReportBugDialog() {
    // 若是官网页面，则不显示提交 bug 的弹窗
    const name = this.$route.name
    const routerList = ['mondomenu', 'contact', 'delivery/pickup', 'aov', 'privacy']
    if (routerList.includes(name)) return
    try {
      await this._showReportBugDialog()
      // @todo get shortCut
      html2canvas(document.body, {
        useCORS: true,
        width: window.screen.availWidth,
        height: window.screen.availHeight,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        x: 0,
        y: window.pageYOffset,
        scale: 1
      }).then(canvas => {
        this.shortCutSrc = canvas.toDataURL()
        this.showReportBugPopupDialog = true
      })
    } catch (error) {
      // console.error(error)
    }
  }

  _sendMsgToBacken() {
    //  iframe 发送数据给父亲
    window.top.postMessage({
      name: 'destopIframeMounted',
      data: 'destopIframeMounted',
    }, '*')
  }

  getVenueUrl() {
    const isOnline = this.isOnline ? '/online' : ''
    const PREFIX = process.env.VUE_APP_CUSTOM_BASE_URL + isOnline + '/v/'
    const venueMark = this.venueInfo.url_id || this.venueInfo.id
    // 多版本菜单 N35（review R4B5-3）：站内浏览器弹窗里「COPY MENU」复制的地址按这一次光顾的入口码拼（进店参数 + 点单链接码一起带上），
    // 不再按此刻的路径猜 —— 柜台 / 通用桌码顾客填过桌号后不会复制成单桌码。没有进店参数时与改动前逐字节相同（utils/menu/menuAddress.js）
    // 第三参（N35-B2 第 5 轮复核）：桌名里有 % 时按这台路由器读地址栏的方式转义，复制出去的地址在服务器的 vue-router 3.3.4 上也打得开
    this.venueUrl = menuCopyUrl(PREFIX + venueMark, this.$route, this.$router)
  }

  controlShowNotMainNavigatorPopupDialog() {
    const notIncludesMainNavigator = !_isIncludesMainNavigator()
    const isVenueHomePage = this.$route.name.includes('venue-home')
    if (this.dialogShow) return
    if (notIncludesMainNavigator && isVenueHomePage) {
      this.showNotMainNavigatorPopupDialog = true
    }
  }

  closeAppInBrowserNotice() {
    this.dialogShow = false
    this.showNotMainNavigatorPopupDialog = true
  }

  reload () {
    this.isRouterAlive = false // 先关闭
    this.$nextTick(() => {
      this.isRouterAlive = true // 再打开
    })
  }

  /**
   * 监听路由变化
   * targetPageList: 目标页面列表
   * allowFromPageList: 来源页面列表
   * mutationName: vuex 中的函数名（变量都放在公共里）
   * toPage: 新路由
   * fromPage: 旧路由
   */
  _saveStatusToVuex(targetPageList, allowFromPageList, mutationName, toPage, fromPage) {
    if (targetPageList.includes(toPage.name) && fromPage.name === IS_SAME_PAGE_NAME) {
      // do nothing
    } else {
      // fresh other page
      if (targetPageList.includes(toPage.name) && allowFromPageList.includes(fromPage.name)) {
        this.$store.commit(mutationName, true)
      } else {
        this.$store.commit(mutationName, false)
      }
    }
  }

  _isFromOrderHistoryToOrderDetail(toPage, fromPage) {
    this._saveStatusToVuex(
      IS_FROM_ORDER_HISTORY_TO_ORDER_DETAIL.TARGET_PAGE_LIST,
      IS_FROM_ORDER_HISTORY_TO_ORDER_DETAIL.ALLOW_FROM_PAGE_LIST,
      IS_FROM_ORDER_HISTORY_TO_ORDER_DETAIL.VUEX_MUTATION_NAME,
      toPage,
      fromPage
    )
  }

  _isFromMenuToStartTab(toPage, fromPage) {
    this._saveStatusToVuex(
      IS_FROM_MENU_TO_START_TAB.TARGET_PAGE_LIST,
      IS_FROM_MENU_TO_START_TAB.ALLOW_FROM_PAGE_LIST,
      IS_FROM_MENU_TO_START_TAB.VUEX_MUTATION_NAME,
      toPage,
      fromPage
    )
  }

  _isFromStartTabToCardDetails(toPage, fromPage) {
    this._saveStatusToVuex(
      IS_FROM_START_TAB_TO_CARD_DETAILS.TARGET_PAGE_LIST,
      IS_FROM_START_TAB_TO_CARD_DETAILS.ALLOW_FROM_PAGE_LIST,
      IS_FROM_START_TAB_TO_CARD_DETAILS.VUEX_MUTATION_NAME,
      toPage,
      fromPage
    )
  }

  _isFromMenuToContactDetail(toPage, fromPage) {
    this._saveStatusToVuex(
      IS_FROM_MENU_TO_CONTACT_DETAIL.TARGET_PAGE_LIST,
      IS_FROM_MENU_TO_CONTACT_DETAIL.ALLOW_FROM_PAGE_LIST,
      IS_FROM_MENU_TO_CONTACT_DETAIL.VUEX_MUTATION_NAME,
      toPage,
      fromPage
    )
  }

  _clearOldVersionUnPaidOrderLocalStorage() {
    const unPaidOrderList = this.$store.state.venueUnpaidOrderList
    if (unPaidOrderList.length) {
      unPaidOrderList.forEach((item, index) => {
        const res = item.createTimeStamp && item.orderType
        if (res) unPaidOrderList.splice(index, 1)
      })
    }
  }

  saveVenueId(venueId) {
    this.$store.commit('saveVenueId', venueId)
  }

  _setDefaultColor() {
    // 同步更改 theme 中的 colorDefault
    const colorDefault = {
      menu_primary_background_colour: '#14C4BC',
      menu_header_background_colour: '#14C4BC',
      menu_header_colour: '#fff',
      menu_primary_text_colour: '#000',
    }
    Object.keys(colorDefault).forEach(item => {
      const res = localStorage.getItem(item)
      if (!res) this.$store.state.app.color[item] = colorDefault[item]
    })
  }

  async _postVenue() {
    try {
      // A/B test framework: ensure orderSeed exists BEFORE any menu/product fetch.
      // Use the URL venueId (decoded) so the seed is bound to the venue the user just opened.
      // A/B 测试框架：在拉取 menu/product 前先确保 orderSeed 已生成，
      // 用 URL 上的 venueId 绑定，下一次进入不同餐厅会自动重新生成。
      // 多版本菜单 B6：URL 上可能是 url_id —— 同一家店的 url_id 不再换 seed；换店时 get-venue 响应里的 resetState
      // 会清掉这一份，紧接着在同一处按门店 UUID 重新绑定（store/venueEntry.js），所以首页的 get-menu 一定带着这一单的 seed。
      const routeVenueId = safeDecodeURI(this.$route.params.venueId)
      await this.$store.dispatch('ensureOrderSeed', { venueId: routeVenueId })

      this.venueInfo = await getVenue({
        id: routeVenueId
      })
      this.saveVenueId(this.venueInfo.id)
      // 给 OpenReplay 打 venue/venueName（全会话每店只发一次），回放可按店过滤
      setVenueMetaOnce(routeVenueId, this.venueInfo.name)
      this.saveVenueSettings('allowPayAtCounter', this.venueInfo.settings.options.allowPayAtCounter,
        this.venueInfo.settings.options.payAtCounterName ? this.venueInfo.settings.options.payAtCounterName : 'Pay at counter')
      // API 中的 enableTab 更换过数据结构，若找不到新数据，就取用旧数据
      const enableTab = this.venueInfo.settings?.dineInSettings?.enableTab ?? this.venueInfo.settings?.options?.enableTab ?? false
      const enableCustomerTab = this.venueInfo.settings?.dineInSettings?.enableCustomerTab ?? false
      this.saveVenueSettings('enableTab', enableCustomerTab)
      const modificationDescSettings = this.venueInfo.settings?.modificationDescSettings ?? {}
      this.saveVenueSettings('saveModificationDescSettings', modificationDescSettings)
      const { primaryColor, headerColor, headerTextColor, headerPrimaryTextColor } = this.venueInfo.settings.styleSettings.main || {
        primaryColor: '#14C4BC',
        headerColor: '#14C4BC',
        headerTextColor: '#fff',
        headerPrimaryTextColor: '#000'
      }
      // 设置 color，改变 css 的变量值
      // menu
      document.body.style.setProperty('--menu-primary-background-colour', primaryColor)
      document.body.style.setProperty('--menu-primary-background-colour-rgb', _hexToRgb(primaryColor))
      document.body.style.setProperty('--menu-header-background-colour', headerColor)
      document.body.style.setProperty('--menu-header-colour', headerTextColor)
      document.body.style.setProperty('--menu-primary-text-colour', headerPrimaryTextColor)

      // 存储到 vuex ，组件从 vuex 拿值
      // menu
      this.$store.commit('saveColor', {
        prop: 'menu_primary_background_colour',
        val: primaryColor
      })
      this.$store.commit('saveColor', {
        prop: 'menu_header_background_colour',
        val: headerColor
      })
      this.$store.commit('saveColor', {
        prop: 'menu_header_colour',
        val: headerTextColor
      })
      this.$store.commit('saveColor', {
        prop: 'menu_primary_text_colour',
        val: headerPrimaryTextColor
      })

      // 存到 localStorage。从 main.js 里拿值
      // menu
      localStorage.setItem('menu_primary_background_colour', primaryColor)
      localStorage.setItem('menu_header_background_colour', headerColor)
      localStorage.setItem('menu_header_colour', headerTextColor)
      localStorage.setItem('menu_primary_text_colour', headerPrimaryTextColor)

      // 附加费：登记判定依据（配置原样 + 门店时区），按服务器时钟刷新一次快照给页面显示；
      // 真正送给后端的 amount 在每个建单请求那一刻再重判一次（utils/surchargeSnapshot.js 的 orderAmountNow）。
      // 判定规则与后端 Venue::getCurrentSurcharge 逐字同义，见 utils/surchargeRate.js。
      // 依据带上是哪家店（多店购物车加别家店的推荐品时据此判断能不能沿用，Codex 第 2 轮 #4）；
      // 时区与 requestMixin 存给页面显示的同一处解析（review 第 1 轮 #11）
      this.$store.commit('saveSurchargeSource', surchargeSourceOf(this.venueInfo))
      refreshSurchargeSnapshot(this.$store)

      // 刷卡手续费率：与后端 Venue::getMerchantRate 同义（先看开关；开着但没填费率按 1.75%）
      this.$store.commit('saveMerchantFee', resolveMerchantRate(this.venueInfo.settings?.options))

      // 保存 force input table 的信息
      if (this.venueInfo.settings && this.venueInfo.settings.options && this.venueInfo.settings.options.forceTableInput) {
        this.$store.commit('saveForceTable', true)
      } else {
        this.$store.commit('saveForceTable', false)
      }

      // Initialize multilingual settings / 初始化多语言配置
      this._initLanguageSettings(this.venueInfo)

      // Initialize currency settings / 初始化货币配置
      this._initCurrencySettings(this.venueInfo)

      // Track session locale after initialization / 初始化后记录会话语言和货币
      this._trackSessionLocale()
    } catch (error) {
      console.log(error)
    }
  }

  /**
   * Initialize multilingual settings from venue info
   * 初始化多语言配置
   *
   * API settings will be merged with built-in defaults (en, fr, zh).
   * API 设置将与内置默认值（en、fr、zh）合并。
   *
   * @param {Object} venueInfo - Venue information object / 餐厅信息对象
   */
  _initLanguageSettings(venueInfo) {
    // Pass API settings and venueId to the action, which will merge with defaults
    // and auto-detect browser language or restore per-venue preference
    // 将 API 设置和 venueId 传递给 action，它将与默认值合并
    // 并自动检测浏览器语言或恢复按餐厅的偏好
    const languageSettings = venueInfo.settings?.languageSettings || null
    const venueId = this.$store.state.venueId || venueInfo.id
    this.$store.dispatch('language/initLanguageSettings', {
      apiSettings: languageSettings,
      venueId,
    })
  }

  /**
   * Initialize currency settings from venue info
   * 初始化货币配置
   *
   * API settings will be merged with built-in defaults.
   * Default currency is determined by: API -> venueSettings.options.defaultCurrency -> AUD
   * API 设置将与内置默认值合并。
   * 默认货币的优先级为：API -> venueSettings.options.defaultCurrency -> AUD
   *
   * @param {Object} venueInfo - Venue information object / 餐厅信息对象
   */
  _initCurrencySettings(venueInfo) {
    // Build currency settings from API or venue options
    // 从 API 或 venue 选项构建货币设置
    let currencySettings = venueInfo.settings?.currencySettings

    // Handle case where currencySettings is a string (just currency code)
    // 处理 currencySettings 是字符串（仅货币代码）的情况
    if (typeof currencySettings === 'string') {
      currencySettings = {
        defaultCurrency: currencySettings,
      }
    }

    // If no currency settings but has defaultCurrency in options, use it
    // 如果没有货币设置但 options 中有 defaultCurrency，使用它
    if (!currencySettings && venueInfo.settings?.options?.defaultCurrency) {
      currencySettings = {
        defaultCurrency: venueInfo.settings.options.defaultCurrency,
      }
    }

    // Pass to action with venueId, which will merge with defaults
    // and restore per-venue currency preference
    // 传递给 action（带 venueId），它将与默认值合并并恢复按餐厅的货币偏好
    const venueId = this.$store.state.venueId || venueInfo.id
    this.$store.dispatch('currencySettings/initCurrencySettings', {
      apiSettings: currencySettings,
      venueId,
    })
  }

  /**
   * Track session locale (language + currency) after initialization
   * 初始化后上报会话语言和货币
   */
  _trackSessionLocale() {
    const sessionLang = this.$store.state.language.currentLanguage
    const sessionCurrency = this.$store.state.currencySettings?.currentCurrency || 'AUD'
    if (this.$openreplayTracker) {
      this.$openreplayTracker.event('session_locale', { language: sessionLang, currency: sessionCurrency })
    }
    if (this.$gtag) {
      this.$gtag.event('session_locale', {
        event_category: 'user_preference',
        event_label: `${sessionLang} / ${sessionCurrency}`,
        language: sessionLang,
        currency: sessionCurrency,
      })
    }
  }

  /**
   * Restore language/currency settings for sub-group child pages
   * 为 sub-group 子页面恢复语言/货币设置
   *
   * When navigating to sub-group child pages (cart, order-history, etc.),
   * language/currency settings may have been overwritten by a venue's _postVenue().
   * This method restores them from the saved sub-group settings in Vuex.
   * 当导航到 sub-group 子页面（购物车、订单历史等）时，
   * 语言/货币设置可能已被 venue 的 _postVenue() 覆盖。
   * 此方法从 Vuex 中保存的 sub-group 设置恢复它们。
   */
  _restoreSubGroupLocaleSettings() {
    const routeName = this.$route.name || ''
    // Only apply to sub-group child pages (not the main listing page which handles its own init)
    // 仅应用于 sub-group 子页面（主列表页自己处理初始化）
    if (!routeName.startsWith('venue-sub-group-')) return

    const subGroupId = this.$store.state.venueHome.subGroupId || this.$route.params?.venueSubGroupId
    if (!subGroupId) return

    const savedSettings = this.$store.state.venueHome.subGroupSettings?.[subGroupId]?.settings
    if (!savedSettings) return

    // Restore language settings / 恢复语言设置
    const languageSettings = savedSettings.languageSettings || null
    this.$store.dispatch('language/initLanguageSettings', {
      apiSettings: languageSettings,
      venueId: subGroupId,
    })

    // Restore currency settings / 恢复货币设置
    let currencySettings = savedSettings.currencySettings || null
    if (typeof currencySettings === 'string') {
      currencySettings = { defaultCurrency: currencySettings }
    }
    this.$store.dispatch('currencySettings/initCurrencySettings', {
      apiSettings: currencySettings,
      venueId: subGroupId,
    })
  }

  saveVenueSettings(type, value, extraValue) {
    if (type === 'allowPayAtCounter') {
      if (value) {
        this.$store.commit('saveAllowCounterPay', true)
      } else {
        this.$store.commit('saveAllowCounterPay', false)
      }
      if (extraValue) {
        this.$store.commit('saveCounterPayName', extraValue)
      }
    } else if (type === 'enableTab') {
      if (value) {
        this.$store.commit('saveEnableTab', true)
      } else {
        this.$store.commit('saveEnableTab', false)
      }
    }
  }

  // 对返回的路由进行设置，强行设置：如果是 cart 页面，则必须返回到 venueHome 页面，这是为了防止商品价格变动、库存不足、商品下架的情况，导致 addOrder 失败后，从 creditCard 或者其他支付页面再返回的情况。
  prev(type = 'normal') {
    if (this.disabledButton) return
    const name = this.$route.name

    // 从 cart 推荐跳转来的 product-detail，返回 cart
    if ((name === 'product-detail-pick' || name === 'product-detail-table') && this.$route.query.fromCart) {
      this.$router.go(-1)
      return
    }

    if (name === 'cart-pick' || name === 'cart-table' || name === 'product-detail-pick' || name === 'contact-details') {
      const number = this.$store.state.venueHome.routerInfo.number
      const noTable = this.$store.state.venueHome?.routerInfo?.noTable ?? false // 是否不带桌号
      const venueId = this.$store.state.venueId
      if (number) {
        this.$router.push({
          path: `/v/${venueId}/home/t/${number}`
        })
      } else {
        if (noTable) {
          this.$router.push({
            path: `/v/${venueId}/t`
          })
        } else {
          this.$router.push({
            path: `/v/${venueId}/home/p`
          })
        }
      }
    } else {
      this.$router.go(-1)
    }
  }

  refactoringUnPaidOrder() {
    /**
      1.pre-paid 状态下，如果未付款中途退出，所生成了 order id，则下一次会直接引用此 order id
      2.pre-paid 状态下，如果引用的 order id 已经关闭或者付款，则直接生成新的 order id
      3.post-paid 状态下，如果有未付款且未完成的 order id，则引用之前的 order id
      4.post-paid 状态下，如果引用的 order id 已经关闭或者付款，则尝试获取最新的未付款且未完成的 order id 并引用。如果再不行，则生成新的 order
    */

    /**
      后台的逻辑是这样的
      1. pre-paid，如果引用的 order 没有付款且未完成，则覆盖此 order，包括时间戳，只保留 id
      2.pre-paid，如果引用的 order 已付款或完成，则生成新的 order
      3. post-paid，如果引用的 order 没有付款其未完成，如果 order 的时间在 24 小时范围内且在同日内，则添加进去，否则生成新的 order
      4. post-paid，如果引用的 order 已经付款或者完成，则生成新的 order
    */
  }

  // 如果是 facebook 和 instgram 中打开的，就显示遮罩层
  _browserType() {
    const ua = navigator.userAgent.toLowerCase()
    const browserType = (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1) || ua.includes('Instagram') || ua.includes('instagram')
    if (browserType) {
      document.body.style.overflow = 'hidden'
      this.dialogShow = true
    }
  }
}

export default Home
</script>
